export const DEFAULT_CAMPAIGN_CLIENT_APP_ID = 3;
export const REQUIRED_FIELDS = [
  "title",
  "trackerId",
  "trafficSource",
  "campaignId",
  "installPostbackUrl",
  "trialPostbackUrl",
  "subscriptionPostbackUrl",
  "active",
];
